<template>
  <div ref="eventDetail">
    <cw-main>
      <a-row>
        <a-col :xl="16">
          <div>
            <a-row>
              <a-col :lg="10">
                <img
                  class="purchase-img"
                  :src="info.eventLargeCoverUrl"
                  alt=""
                />
              </a-col>
              <a-col :lg="14" class="purchase-msg-details">
                <div class="title">{{ getName(info, 'eventName') }}</div>
                <div class="status">
                  <span>{{ getLabelCode('common.event.status') ?? $t('event-status') }}&nbsp;</span>
                  <span class="status-value">{{ $t(statusObj[info.status]) }}</span>
                </div>
                <div class="date" v-if="info.eventDate">
                  <span>{{ getLabelCode('common.event.time') ?? $t('event-date') }}&nbsp;</span>
                  <span>{{ info.eventDate }}</span>
                </div>
                <div class="ara" v-if="getName(info.venue, 'venueName')">
                  <span>{{ getLabelCode('common.event.time') ?? $t('event-venue') }}&nbsp;</span>
                  <span>{{ getName(info.venue, 'venueName') }}</span>
                </div>
                <div class="eventTags" v-if="tagList.length > 0">
                  <span v-for="(tag, idx) in tagList" :key="idx">
                    {{tag}}
                  </span>
                </div>
              </a-col>
            </a-row>
            <a-row>
              <a-col class="info-item">
                <div class="info-title">{{ $t('event-presenter') }}</div>
                <div class="info-desc">
                  {{ getName(info, 'presenterName') }}
                </div>
              </a-col>
              <a-col
                class="info-item"
                v-for="(item, index) in (info.descriptions || []).slice(0,1)"
                :key="index"
              >
                <div class="info-title">{{ getName(item, 'title') }}</div>
                <div class="info-desc" v-html="getName(item, 'content')"></div>
              </a-col>
              <a-col
                class="info-item info-item-more"
                :class="showMore ? 'show' : ''"
                v-for="(item, index) in (info.descriptions || []).slice(1)"
                :key="'more-' + index"
              >
                <div class="info-title">{{ getName(item, 'title') }}</div>
                <div class="info-desc" v-html="getName(item, 'content')"></div>
              </a-col>
              <a-col v-if="info.descriptions && info.descriptions.length > 1">
                <div class="event-more-detail" v-show="!showMore" @click="showMore = true">
                  <span>{{ $t('event-more-detail') }}</span>
                  <a-icon type="down"/>
                </div>
                <div class="event-less-detail" v-show="showMore" @click="showMore = false">
                  <span>{{ $t('event-less-detail') }}</span>
                  <a-icon type="up"/>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :xl="8" v-if="performances.length > 0">
          <div class="aside" width="100%">
            <div class="purchase-buy">
              <select-date
                :dateList="performances"
                :limitObj="limitObj"
                readonly
              ></select-date>
              <div class="title">
                <div class="price-name">{{ $t('price-title') }}</div>
                <div class="price-btn-wrap">
                  <a-button
                    v-for="(item, index) in priceList"
                    :key="index"
                    class="card-button"
                  >
                    {{ $amountRule(item.price) }}
                    <img
                      v-if="limitObj[item.status]"
                      class="limited-img"
                      src="@/assets/images/limited.svg"
                      :alt="$t(limitObj[item.status])"
                    />
                  </a-button>
                </div>
              </div>
              <div class="ticketCard">
                <a-button type="primary" @click="handleClickBuy">{{
                  $t('button.purchase.title')
                }}</a-button>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </cw-main>
  </div>
</template>

<script>
import cwMain from '@/components/container/cw-main'
import selectDate from '@/components/selectDate'
import { getUtsvField } from '@/utils/utils'
import { getEventDetailApi, getPerformancesApi } from '@/api/utsv'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    cwMain,
    selectDate
  },
  data () {
    return {
      info: {},
      performances: [],
      statusObj: {
        TOBESOLD: 'event-status-tobesold',
        SALE: 'event-status-sale',
        SOLDOUT: 'event-status-soldout',
        TOBESOEXPIREDLD: 'event-status-expired'
      },
      limitObj: {
        AVAILABLE: null,
        LIMIT: 'status-title-limit',
        SOLDOUT: 'status-title-soldout'
      },
      priceList: [],
      eventId: this.$route.query.event,
      showMore: false
    }
  },
  created () {
    this.getEventDetail()
  },
  computed: {
    getName () {
      return (obj, name) => {
        return obj ? getUtsvField(obj, name, this.$i18n.locale) : ''
      }
    },
    ...mapState(['login']),
    ...mapGetters(['getLabelCode']),
    tagList () {
      if (!this.info) {
        return []
      }
      const hashTag = this.getName(this.info, 'hashtag')
      if (!hashTag) {
        return []
      }
      return hashTag.split('#').slice(1)
    }
  },
  methods: {
    async getEventDetail () {
      const [info, { performances }] = await Promise.all([getEventDetailApi(this.eventId), getPerformancesApi(this.eventId)])
      console.log('info:', info)
      console.log('performances:', performances)
      this.info = info
      this.performances = performances
      for (let i = performances.length - 1; i >= 0; i--) {
        if (performances[i].status !== 'SOLDOUT') {
          this.priceList = performances[i].pricelist
          break
        }
      }
    },
    handleClickBuy () {
      this.$router.push({
        name: 'Performance',
        params: {
          activityCode: this.$route.params.activityCode
        },
        query: {
          event: this.eventId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.aside {
  padding: 0 10px;
  @media (max-width: 991px) {
    padding: 0;
  }
}

.purchase-img {
  width: 15rem;
  @media (max-width: 991px) {
    width: 100%;
  }
}

.purchase-msg-details {
  padding-left: 3rem;
  @include font_color('detail-info');

  @media (max-width: 991px) {
    padding-left: 0;
  }

  > div {
    font-size: 1.125rem;
    margin-top: 1.875rem;
    @media (max-width: 991px) {
      font-size: 0.75rem;
      margin-top: 0.75rem;
    }
  }

  .title {
    margin-top: 0;
    font-size: 1.875rem;
    @include font_color('detail-title');
    font-weight: 500;
    line-height: 1.2;
    @media (max-width: 991px) {
      font-size: 1.3125rem;
    }
  }

  .status-value {
    @include font_color('detail-status');
  }

  .eventTags {
    display: flex;
    flex-wrap: wrap;
    font-size: 1.125rem;
    margin-top: 1.875rem;
    @include font_color('detail-info');
    margin: 1.875rem -4px;
    span {
      display: inline-block;
      margin: 2px 4px 0;
      padding: 0 7px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #000;
      @include border_color('black-border_color');
    }
  }
}

.info-item {
  margin-top: 12px;
  @include font_color('detail-info');
  font-size: 1rem;

  &.info-item-more {
    @media (max-width: 1199px) {
      display: none;
      &.show {
        display: block;
      }
    }
  }

  .info-title {
    font-weight: bold;
  }
}

.purchase-buy {
  > div {
    padding: 0 5px;
    @media (max-width: 991px) {
      padding: 0;
    }
  }

  .title {
    color: $theme-color;
    font-size: 1.3125rem;
    font-weight: 700;
  }

  .card-button {
    width: 100%;
    height: auto;
    margin: 0.625rem 0;
    padding: 6px;
    display: flex;
    justify-content: center;
    white-space: initial;
    font-size: 1.3125rem;
    border: 0.125rem solid #ced4da;
    background: transparent;
  }

  .price-box {
    margin: 27px 0;
  }

  .ticketCard {
    margin: 45px 25px;
    padding: 20px;

    .ant-btn {
      width: 100%;
      height: 2.9375rem;
      font-size: 1.125rem;
      border-radius: 0.3125rem;
      border: none;
      background: $theme-color-gradient;
    }
    @include mobileStyle() {
      padding: 0;
      background: none;
    }
  }
}

.price-btn-wrap {
  display: flex;
  flex-wrap: wrap;

  .ant-btn {
    margin: 0.5%;
    width: 32%;
    position: relative;
    color: $theme-color;
    cursor: unset;
  }
  .limited-img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0.125rem;
    width: 1.25rem;
    height: 1.25rem;
    background: #f2c94c;
    padding: 3px;
    border-radius: 1rem;
  }
}

.event-more-detail,
.event-less-detail {
  display: flex;
  align-items:center;
  justify-content: center;
  margin: 20px 0;
  font-size: 0.75rem;
  color: $theme-color;
  cursor: pointer;
  i {
    margin-left: 5px;
  }
}
</style>
